import { render, staticRenderFns } from "./wantCoursedetail.vue?vue&type=template&id=6e6cc706&scoped=true&"
import script from "./wantCoursedetail.vue?vue&type=script&lang=js&"
export * from "./wantCoursedetail.vue?vue&type=script&lang=js&"
import style0 from "./wantCoursedetail.vue?vue&type=style&index=0&id=6e6cc706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6cc706",
  null
  
)

export default component.exports